import {TrackPageViewContainer} from '../../../common/containers/TrackPageViewContainer';
import {useGetDayOfWeekLayoutData} from '../hook/useGetDayOfWeekLayoutData';
import {DayOfWeekLogProps} from '../type';

type Props = DayOfWeekLogProps;

export const DayOfWeekPageViewHeadless = ({...rest}: Props) => {
  const layoutData = useGetDayOfWeekLayoutData(rest);
  const dayName = layoutData.currentDayItem.name;
  const referenceName = layoutData.currentReferenceItem.name;
  const sortName = layoutData.currentSortItem.name;

  return (
    <TrackPageViewContainer
      key={`요일연재_${dayName}_${referenceName}_${sortName}`}
      trackObj={{
        shouldSendUsagePage: true,
        shouldSendUsageScroll: true,
        section: '요일연재',
        // "요일연재_{요일명} (ex. 요일연재_월, 요일연재_화..)"
        page: `요일연재_${dayName}`,
        // "요일연재_{요일명}_화면 (ex. 요일연재_월, 요일연재_화..)"
        actionName: `요일연재_${dayName}_화면`,
        actionType: 'Pageview',
        customProps: {
          user_action: 'pv',
          // "{타입명} (ex. 전체, 페이지에서만, 웹툰, 웹소설...(1열, 2열, 3열 명칭 노출)"
          page_filter: referenceName,
          // "{요일명} (ex. 월, 화, 수...)"
          page_day: dayName,
          // "{정렬 옵션명} (ex. 인기순, 추천순, 남성인기순..)"
          page_sort: sortName,
        },
      }}
    />
  );
};
